var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Cards "),_c('b-table',{attrs:{"responsive":"","striped":"","hover":"","sort-icon-left":"","name":"cards-table","items":_vm.filteredCards,"fields":_vm.sortFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }